var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-icon"},[_c('img',{staticClass:"favicon",attrs:{"src":_vm.favicon}}),_c('div',{staticClass:"icon",style:(_vm.colors[_vm.event])},[_c(_vm.statusIcons[_vm.event],{tag:"component",attrs:{"width":"10","height":"10"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }